import { Injectable } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ITranslationInitializer} from './itranslation-initializer';

declare function DoraGetLocale(): string;

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  protected locale: string;
  private caller: ITranslationInitializer;
  // tslint:disable-next-line:ban-types
  private vocabolary: Object = null;
  constructor(protected translate: TranslateService) {
    this.locale = DoraGetLocale();
    this.translate.setDefaultLang(this.locale);
  }

  public initialize(caller: ITranslationInitializer): void {
    this.caller = caller;
    this.translate.getTranslation(this.locale).subscribe((res: any) => {
      this.vocabolary = res;
      this.caller.onTranslationInitialized();
    });
  }

  /**
   * Get the translation of a key. If not exist return the key.
   * @param key string to translate
   */
  public get(key: string): string {
    const result = this.vocabolary[key];
    if (result === undefined) {
      return key;
    }

    return result;
  }

  /**
   * Get the translation of a key. If not exist return the default value.
   */
  public getWithDefault(key: string, defaultValue: string): string {
    const result = this.vocabolary[key];
    if (result === undefined) {
      return defaultValue;
    }

    return result;
  }

  /**
   * Check if the key exist in the translation file
   */
  public keyExist(key: string): boolean {
    return this.vocabolary[key] !== undefined;
  }
}
